import { useCallback } from 'react';
import { useIntl } from 'react-intl';

interface Params {
  [key: string]: string;
}

export const useTranslate = () => {
  const { formatMessage } = useIntl();

  return useCallback((id: string, defaultMessage?: string, params?: Params) => (
    formatMessage({ id, defaultMessage }, params)
  ), [formatMessage]);
};
